import { Component, Inject,  ViewChild,  ElementRef, OnInit, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';


import { GestockService } from '../services/gestock.service';


@Component({
  selector: 'app-text-description-dialog',
  templateUrl: './text-description-dialog.component.html',
  styleUrls: ['./text-description-dialog.component.css']
})
export class TextDescriptionDialogComponent implements OnInit {
  description: string;

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
  spinnerDialogRef : any ;
  etatreq = "" ;

  retourClientWS : any ;

  samacaabiyoonwii = "" ;

  product : any ;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TextDescriptionDialogComponent>,
        private configServer: GestockService, 
           public dialog: MatDialog) {

    this.product = data.product;
    this.description = data.product.description || '';
  }

/*
$article_id = $json->id ;
$infoToUpdt = $json->infoToUpdt ;
$newValue = $json->newValue ;

$detailsarticle = $json->detailsarticle ;
*/

  ngOnInit(){
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;    
  }


  mettreAjourDescriptArticleBi(){
    let infoToUpdt = "description" ;
    let newValue =  this.description ;
    let idarticle = this.product.id ;
    let detailsarticle = this.product.detailsarticle ;

    this.openSpinnerDialog() ;
    this.configServer.mettreAjourDetailsArticleBi(this.samacaabiyoonwii, idarticle, infoToUpdt, newValue, detailsarticle).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.etatreq='successful' ;
        console.log("Mbirr Yi Matna") ;
      }
      else{
        this.etatreq='failed' ;
        console.log("Failed") ;
      }
    }) ;    
  }


  save() {
    this.dialogRef.close({ description: this.description });
  }

  cancel() {
    this.dialogRef.close();
  }

  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }

  close(){
    this.dialogRef.close();    
  }



}
